export const TALENTS_PAGE_FILTERS = {
  QUERY: 'query',
  COMPANY: 'companies',
};
